import axios from "axios";

interface ApiResponse {
  data: any[];
  status: string;
}

const API_BASE_URL =
  window.location.hostname === "localhost"
    ? "http://localhost/api_server"
    : "https://www.ppkm.org.my/api_server";

const getResourcesCategories = async () => {
  try {
    const { data } = await axios.get<ApiResponse>(
      `${API_BASE_URL}/get_document_categories/`
    );
    return data;
  } catch (error) {
    return error;
  }
};

const deleteDocumentCategoryRow = async (payload: any) => {
  try {
    const { data } = await axios.post<ApiResponse>(
      `${API_BASE_URL}/delete_document_category/`,
      payload
    );
    console.log(data);
    return data;
  } catch (error) {
    return error;
  }
};

const saveRowDocumentCategory = async (payload: any) => {
  try {
    const { data } = await axios.post<ApiResponse>(
      `${API_BASE_URL}/submit_edit_document_category/`,
      payload
    );
    console.log(data);
    return data;
  } catch (error) {
    return error;
  }
};

const createDocument = async (data: any) => {
  console.log('checkData: ' + JSON.stringify(data));

  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };
  try {
    const response = await axios.post(
      `${API_BASE_URL}/create_document/`,
      data,
      config
    );
    return response.data;
  } catch (error) {}
};

const getDocuments = async () => {
  try {
    const { data } = await axios.get<ApiResponse>(
      `${API_BASE_URL}/get_documents/`
    );
    return data;
  } catch (error) {
    return error;
  }
};

const editDocuments = async (payload: any) => {
  try {
    const { data } = await axios.post<ApiResponse>(
      `${API_BASE_URL}/edit_documents/`,
      payload
    );
    console.log(data)
    return data;
  } catch (error) {
    return error;
  }
};

const deleteDocuments = async (payload: any) => {
  try {
    const { data } = await axios.post<ApiResponse>(
      `${API_BASE_URL}/delete_documents/`,
      payload
    );
    return data;
  } catch (error) {
    return error;
  }
};

const api = {
  getResourcesCategories,
  deleteDocumentCategoryRow,
  saveRowDocumentCategory,
  createDocument,
  getDocuments,
  editDocuments,
  deleteDocuments,
};

export default api;